<template>
  <section class="content">
    <div class="box box-info">
      <div class="p-field p-col-12">
        <a href="#" @click.prevent="exportCSV()" v-if="this.bankClosingBalEcludingOverDraftList.length > 0">
          <img src="../../../../static/img/excel.png" style="float: right;height: 3em;width: 3em;"/>
        </a>
      </div>
      <!-- DataTable for PartyStatement -->
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable :value="bankClosingBalEcludingOverDraftList"
                     :paginator="true"
                     :rowsPerPageOptions="[100,500,1000]"
                     :rows="100" :filters="filters"
                     class="p-datatable-responsive-demo p-datatable-gridlines"
                     data-key="id">
            <template #empty>No record found</template>
            <Column header="S.N">
              <template #body="sl">
                {{ sl.index + 1 }}
              </template>
            </Column>
            <Column header="Bank Name" field="name">
            </Column>
            <Column :sortable="true" header="Account Number" field="accountNumber"/>
            <Column :sortable="true" header="Account Type" field="type"/>
            <Column :sortable="true" header="Branch" field="branch"/>
            <Column :sortable="true" header="Closing Balance" bodyStyle="text-align: right"
                    field="closingBalance"/>
            <Column :sortable="true" header="Dr-Cr" bodyStyle="text-align: right"
                    field="drCr"/>
          </DataTable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default {
  data() {
    return {
      bankClosingBalEcludingOverDraftList: []
    }
  },
  mounted() {
    this.searchBankClosingEcludingOverDraft()
  },
  methods: {
    async searchBankClosingEcludingOverDraft() {
      let response = await this.$store.dispatch('bankClosingExcludingOverDraft')
      this.bankClosingBalEcludingOverDraftList = response.data.data
    }
  },
  components: {
    DataTable,
    Column
  }
}
</script>



// WEBPACK FOOTER //
// bankClosingBalExcludingOverDraft.vue?756d7388